export default [
  {
    fullName: 'Антон степанов',
    jobTitle: 'Генеральный директор ',
    description: 'Т1 Облако',
    photo: require('@/assets/speakers/Степанов А.В..jpg')
  },
  {
    fullName: 'Дмитрий Сендюрев',
    jobTitle: 'Управляющий директор - вице-президент',
    description: 'ВТБ',
    photo: require('@/assets/speakers/photo1719909685.jpeg')
  },
  {
    fullName: 'Андрей Никитин',
    jobTitle: 'Директор по продуктам',
    description: 'Т1 Облако',
    photo: require('@/assets/speakers/Андрей Никитин (1).png')
  },
  {
    fullName: 'Алексей Лесных',
    jobTitle: 'Владелец продукта WatchDog',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Aleksey Lesnyh.png')
  },
  {
    fullName: 'Тимур Нормурадов',
    jobTitle: 'Владелец продукта MARS',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Timur Normuradov.png')
  },
  {
    fullName: 'Алексей Кубарев',
    jobTitle: 'Директор по информационной безопасности ',
    description: 'Т1 Облако',
    photo: require('@/assets/speakers/Кубарев А_2.jpg')
  },
  {
    fullName: 'Алан Миллер',
    jobTitle: 'Руководитель службы автоматизации, управление облачными решениями',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Миллер Алан.jpg')
  },
  {
    fullName: 'Алексей Светличный',
    jobTitle: 'Лидер DataBase Team',
    description: 'Т-Банк',
    photo: require('@/assets/speakers/Alexandr Svetlichnyi.png')
  },
  {
    fullName: 'Матвей Крапошин',
    jobTitle: 'Ведущий системный архитектор',
    description: 'Т1 Сервионика',
    photo: require('@/assets/speakers/Крапошин Матвей.jpg')
  },
  {
    fullName: 'Олег Бондарь',
    jobTitle: 'Директор продукта YDB',
    description: 'Яндекс',
    photo: require('@/assets/speakers/Oleg Bondar.png')
  },
  {
    fullName: 'Павел Иваников',
    jobTitle: 'Директор по ИТ-архитектуре',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Иваников Павел.png')
  },
  {
    fullName: 'Михаил Тутаев',
    jobTitle: 'СPO',
    description: 'MWS',
    photo: require('@/assets/speakers/Frame.png')
  },
  {
    fullName: 'Борис Кедров',
    jobTitle: 'Старший руководитель направления WatchDog',
    description: 'Т1 Иннотех',
    photo: require('@/assets/speakers/Boris Kedrov.png')
  },
  {
    fullName: 'Дмитрий Пыряков',
    jobTitle: 'Руководитель отдела развития сервисов управления виртуальными машинами',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Пыряков Дмитрий.png')
  },
  {
    fullName: 'Андрей Евсюков',
    jobTitle: 'Директор по управлению проектами ДППСиС',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Andrey Evsukov.png')
  },
  {
    fullName: 'Георгий Шнейдер',
    jobTitle: 'Ведущий инженер',
    description: 'Т1 Облако',
    photo: require('@/assets/speakers/Шнайдер Георгий.jpg')
  },
  {
    fullName: 'Игорь Плотников',
    jobTitle: 'Руководитель направления сервисов ИБ',
    description: 'Т1 Облако',
    photo: require('@/assets/speakers/Плотников Игорь.jpg')
  },
  {
    fullName: 'Юрий Разумейченко',
    jobTitle: 'Эксперт-инженер WatchDog',
    description: 'Т1 Иннотех',
    photo: require('@/assets/speakers/Yuriy Razumejchenko.png')
  },
  {
    fullName: 'Михаил Соловьев',
    jobTitle: 'Руководитель по развитию технологической независимости ИТ Инфраструктуры',
    description: 'Т-Банк',
    photo: require('@/assets/speakers/Mikhail Solovyev.jpg')
  },
  {
    fullName: 'Андрей Ушаков',
    jobTitle: 'Директор проектов, стрим "Развитие технологий для продаж и обслуживания в Колл-центре" ',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Andrey Ushakov.png')
  },
  {
    fullName: 'Евгений Бороздин',
    jobTitle: 'Старший системный архитектор УАБД',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Evgeniy Borozdin.png')
  },
  {
    fullName: 'Виталий Иванов',
    jobTitle: 'Главный разработчик отдела разработки коммуникационной платформы Иннотех',
    description: 'Т1 Иннотех',
    photo: require('@/assets/speakers/Vitliy Ivanov.png')
  },
  {
    fullName: 'Павел Исаев',
    jobTitle: 'Директор по управлению портфелем проектов, лидер кластера "Работа с данными" ДППСиС',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Pavel Isaev.png')
  },
  {
    fullName: 'Анатолий Тутынин',
    jobTitle: 'Директор отдела контроля ИТ-производства',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Anatoliy Tutynin.png')
  },
  {
    fullName: 'Николай Федоров',
    jobTitle: 'Начальник УНиС ДИТА',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Nikolay Fedorov.png')
  },
  {
    fullName: 'Александр Хохлов',
    jobTitle: 'Начальник УАБД',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Alexandr Hohlov.png')
  },
  {
    fullName: 'Вознесенский Дмитрий ',
    jobTitle: 'Директор по ИТ-Архитектуре',
    description: 'ВТБ',
    photo: require('@/assets/speakers/5247232945515783140.jpg')
  },
  {
    fullName: 'Александр Черкашин',
    jobTitle: 'Руководитель проекта SyncXpert УАБД',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Alexandr Cherkashin.png')
  },
  {
    fullName: 'Цымбалов Сергей',
    jobTitle: 'Главный разработчик',
    description: 'Банк ВТБ, УАБД',
    photo: require('@/assets/speakers/Cymbalov Sergey.png')
  },
  {
    fullName: 'Роман Журин',
    jobTitle: 'Руководитель СитЦентра ДППСиС',
    description: 'ВТБ',
    photo: require('@/assets/speakers/Roman Zhurin.png')
  },
  {
    fullName: 'Антон Груздев',
    jobTitle: 'Технический директор',
    description: 'MIND Software',
    photo: require('@/assets/speakers/Груздев Антон.jpg')
  },
  {
    fullName: 'Алексей Мальнев',
    jobTitle: 'Директор по развитию сервисного и технологического партнерства',
    description: 'Positive Technologies',
    photo: require('@/assets/speakers/Мальнев (1).jpg')
  },
  {
    fullName: 'Дмитрий Ли',
    jobTitle: 'представитель Клиента',
    description: '',
    photo: require('@/assets/speakers/Ли.jpg')
  }
]
